import { useCallback, useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import {
  Link,
  useLocation,
  useNavigate,
  useRouter,
} from '@tanstack/react-router'

import { useAuth } from '@/services/auth/auth.store'
import { profileAccount } from '@/services/profile/profile.gql'

import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar'
import { Button } from '../ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'

function SiteHeader() {
  return (
    <header
      className="bg-background sticky top-0 z-50"
      style={{
        boxShadow: '0px 4px 30px 0px rgba(28, 18, 157, 0.1)',
      }}
    >
      <div className="container mx-auto flex h-16 items-center justify-between gap-4">
        <Link className="flex w-32 shrink-0 pl-2" to="/">
          <img src="/img/logo/logo-red.png" />
        </Link>
        <AuthNav />
        <UserNav />
      </div>
    </header>
  )
}

function AuthNav() {
  const isAuthenticated = useAuth((s) => s.isAuthenticated)
  const { pathname } = useLocation()

  const redirect = useMemo(() => {
    return pathname?.startsWith('/auth') || pathname === '/'
      ? undefined
      : pathname
  }, [pathname])

  if (isAuthenticated) {
    return null
  }

  return (
    <div className="flex gap-2">
      <Button variant={'outline'} asChild>
        <Link to="/auth/login" search={{ redirect }}>
          Masuk
        </Link>
      </Button>
      <Button variant={'yes'} asChild>
        <Link to="/auth/register">Daftar</Link>
      </Button>
    </div>
  )
}

function UserNav() {
  const isAuthenticated = useAuth((s) => s.isAuthenticated)
  const logout = useAuth((s) => s.logout)
  const router = useRouter()
  const navigate = useNavigate()
  const { data, isError, isSuccess } = useQuery({
    ...profileAccount.qry(),
    throwOnError: false,
    enabled: isAuthenticated,
  })

  const onLogout = useCallback(() => {
    logout().then(() => {
      router.invalidate()
      navigate({ to: '/auth/login' })
    })
  }, [logout])

  if (isError || !data || !isSuccess) {
    return null
  }

  const { email, name } = data.getProfile.profile
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full">
          <Avatar className="h-8 w-8">
            <AvatarImage
              // src={avatar!}
              alt={name}
            />
            <AvatarFallback>{name.slice(0, 2).toUpperCase()}</AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm leading-none font-medium">{name}</p>
            <p className="text-muted-foreground text-xs leading-none">
              {email}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem>Profile</DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem className="w-full" asChild>
          <button onClick={onLogout}>Keluar</button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { SiteHeader }
